export default __webpack_public_path__ + "static/media/photo8.44516963.jpg";